import { AddProductContextProvider } from "./AddProductView";
import AddProduct from "./views/AddProduct";

export const AddProductPage = () => {
  return (
    <AddProductContextProvider>
      <AddProduct />
    </AddProductContextProvider>
  );
};
